import { Route, Routes } from "react-router-dom";
import { OnboardingStepper } from "./stepper";
import { CurrentStep } from "./stepper/CurrentStep";
import {
  Prediction,
  CreatingPlan,
  Email,
  Name,
  PlanChart,
  FinalQuestionsWrapper
} from "./finalQuestions";
import { Upsale } from "../shared/components/upsale";
import { RoutesWithEmail } from "@api/RoutesWithEmail";
import { Confident } from "./stepper/questions/confident";
import { UserActivation } from "src/routes/activate";
import { ThankyouPage } from "src/routes/thankyoupage";

export const Easyfit = () => {
  return (
    <Routes>
      <Route element={<OnboardingStepper />} path="/onboarding">
        <Route element={<CurrentStep />} path="/onboarding/:stepIndex" />
      </Route>
      <Route element={<FinalQuestionsWrapper />}>
        <Route path="/prediction" element={<Prediction />} />
        <Route path="/confident" element={<Confident />} />
        <Route path="/creating-plan" element={<CreatingPlan />} />
        <Route path="/email" element={<Email />} />
        <Route path="/name" element={<Name />} />
        <Route path="/plan-chart" element={<PlanChart />} />
      </Route>
      <Route element={<RoutesWithEmail />}>
        <Route element={<Upsale />} path="/upsale" />
        <Route element={<UserActivation />} path="/activate" />
        <Route element={<ThankyouPage />} path="/thankyou" />
      </Route>
    </Routes>
  );
};
